import request from '@/utils/http.js';

// C端用户登录地址 http://yapi.vhall.domain/project/101/interface/api/60123
const interactsFthdCustomerLogin = (params = {}) => {
  let url = '/v3/interacts/fthd/customer-login';

  return request({
    url: url,
    method: 'GET',
    params: params
  });
};

const hixcApi = {
  interactsFthdCustomerLogin
};

export default hixcApi;
